/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';
import { ModalBody } from '@atlaskit/modal-dialog';
import { N0 } from '@atlaskit/theme/colors';
var smallModalStyles = css({
  height: '20vh',
  minHeight: '320px',
  background: "var(--ds-surface-overlay, ".concat(N0, ")"),
  borderRadius: "var(--ds-border-radius, 3px)"
});
var mediumModalStyles = css({
  height: '40vh',
  minHeight: '520px',
  background: "var(--ds-surface-overlay, ".concat(N0, ")"),
  borderRadius: "var(--ds-border-radius, 3px)"
});
var largeModalStyles = css({
  height: '70vh',
  minHeight: '720px',
  background: "var(--ds-surface-overlay, ".concat(N0, ")"),
  borderRadius: "var(--ds-border-radius, 3px)"
});
var xlargeModalStyles = css({
  height: '90vh',
  background: "var(--ds-surface-overlay, ".concat(N0, ")"),
  borderRadius: "var(--ds-border-radius, 3px)"
});
var maxModalStyles = css({
  height: '100%',
  background: "var(--ds-surface-overlay, ".concat(N0, ")"),
  borderRadius: "var(--ds-border-radius, 3px)"
});

// TODO: Fix below styles once we move to compiled/react
export var ModalContentWrapper = function ModalContentWrapper(_ref) {
  var children = _ref.children,
    size = _ref.size,
    styles = _ref.styles;
  switch (size) {
    case 'small':
      return (
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        jsx("div", {
          css: [smallModalStyles],
          style: styles
        }, children)
      );
    case 'medium':
      return (
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        jsx("div", {
          css: [mediumModalStyles],
          style: styles
        }, children)
      );
    case 'large':
      return (
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        jsx("div", {
          css: [largeModalStyles],
          style: styles
        }, children)
      );
    case 'xlarge':
      return (
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        jsx("div", {
          css: [xlargeModalStyles],
          style: styles
        }, children)
      );
    case 'max':
      return (
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        jsx("div", {
          css: [maxModalStyles],
          style: styles
        }, children)
      );
    default:
      return jsx(ModalBody, null, children);
  }
};
export var getAtlasKitModalWidth = function getAtlasKitModalWidth(modalSize) {
  if (modalSize === 'xlarge') {
    return 'x-large';
  }
  if (modalSize === 'max') {
    return '100%';
  }
  return modalSize;
};